module.exports = __webpack_public_path__ + "img/violet_059.998329e8.png";